import { createCallable } from "./_sdk/client";

//// AI
import type { handlers as aiHandlers } from "./ai/handlers";
const ai = createCallable<typeof aiHandlers>("ai");
////

export {
    ai
};
